import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, makeStyles, TextField, withStyles, MenuItem, Select, Checkbox } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { getOrdersAndCheckInput } from '../../../actions/utActions';
import ReactExport from "react-export-excel";
import FullscreenLoading from '../../Common/FullscreenLoading';
import { showAlertSnackbar } from '../../../reducers/uiSlice';
import { Autocomplete } from '@material-ui/lab';

const FixedTextField = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-input': {
            padding: '10px !important',
        },
        width: 300,
        marginBottom: 20,
    },
}))(TextField);

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexWrap: 'wrap'
    },
    buttonGroup: {
        justifyContent: 'flex-end',
        alignItems: 'center',
        display: 'flex',
        width: '100%'
    },
    button: {
        marginBottom: 30
    },
    searchGroup: {
        display: 'flex',
        marginBottom: 20,
        alignItems: 'center'
    }
}));

function OrderListDownload() {
    const ExcelFile = ReactExport.ExcelFile;
    const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
    const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

    const classes = useStyles();
    const dispatch = useDispatch();
    const { t } = useTranslation('updateToolbox');

    const filterStateList = [
        {
            text: t('190'),
            value: 190
        },
        {
            text: t('195'),
            value: 195
        },
        {
            text: t('199'),
            value: 199
        },
        {
            text: t('202'),
            value: 202
        },
        {
            text: t('231'),
            value: 231
        },
        {
            text: t('232'),
            value: 232
        },
        {
            text: t('211'),
            value: 211
        },
        {
            text: t('206'),
            value: 206
        },
    ]

    const partners = useSelector(state => state.mapManagement.getPartners);

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [disabled, setDisabled] = useState(true);
    const [searchInput, setSearchInput] = useState('');
    const [searchType, setSearchType] = useState("bag_nos");
    const [expressType, setExpressType] = useState(-1);
    const [signatureType, setSignatureType] = useState(-1);
    const [filterStates, setFilterStates] = useState(filterStateList);
    const [partnerId, setPartnerId] = useState(-1);
    const [isLg, setIsLg] = useState(0);
    const [carrierType, setCarrierType] = useState(-1);

    const handleSearchInput = (event) => {
        setSearchInput(event.target.value);
    };

    function transferSearchInput(input) {
        let newInput = input.split('\n');
        return newInput.map(input => { return input.trim() }).toString();
    }

    function handleSubmit() {
        setLoading(true);
        let params = {};
        params['is_LG'] = isLg;
        if (partnerId !== -1) {
            params['partner_id'] = partnerId;
        }
        if (filterStates?.length > 0 && filterStates.length !== filterStateList.length) {
            let filterStatesValue = filterStates.map((state) => state.value);
            params['state'] = filterStatesValue.toString();
        }
        if (expressType !== -1) {
            params['express_type'] = expressType;
        }
        if (signatureType !== -1) {
            params['signature_type'] = signatureType;
        }
        if (carrierType !== -1) {
            params['carrier_type'] = carrierType;
        }
        params[searchType] = transferSearchInput(searchInput);
        dispatch(getOrdersAndCheckInput(params))
            .then((res) => {
                setData(res);
                dispatch(showAlertSnackbar({ message: t('fetch_data_success'), type: 'success' }));
            })
            .catch(() => {
                dispatch(showAlertSnackbar({ message: t('fetch_data_fail'), type: 'error' }));
            })
            .finally(() => {
                setLoading(false);
            })
    }
    function handleFilterStateAll() {
        if (filterStates.length === filterStateList.length) {
            setFilterStates([]);
        } else {
            setFilterStates(filterStateList);
        }

    }

    useEffect(() => {
        setDisabled(searchInput.trim() === '');
    }, [searchInput])

    return (
        <>
            <div className={classes.root}>
                <div>
                    <FixedTextField
                        required
                        variant='outlined'
                        placeholder={t('input_box_tracking_no')}
                        onChange={handleSearchInput}
                        multiline
                        rows={6}
                        value={searchInput}
                    />
                </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        marginLeft: 30,
                        width: '70%'
                    }}
                >
                    <div className={classes.searchGroup}>
                        <TextField
                            id='search_type'
                            label={t('search_type')}
                            name="type"
                            variant="outlined"
                            value={searchType}
                            onChange={(e) => {
                                setSearchType(e.target.value)
                            }}
                            select
                            style={{ width: 200, marginRight: 20 }}
                        >
                            <MenuItem value={'bag_nos'}>{t('bag')}</MenuItem>
                            <MenuItem value={'references'}>{t('reference')}</MenuItem>
                            <MenuItem value={'sub_references'}>{t('sub_reference')}</MenuItem>
                        </TextField>
                        <TextField
                            id='partner_id'
                            label={t('partner')}
                            name="type"
                            variant="outlined"
                            value={partnerId}
                            onChange={(e) => {
                                setPartnerId(e.target.value)
                            }}
                            select
                            style={{ width: 200, marginRight: 20 }}
                        >
                            <MenuItem value={-1}>{t('all')}</MenuItem>
                            {
                                partners?.length > 0 &&
                                partners.map((partner) => (
                                    <MenuItem value={partner.id} key={partner.id}>{partner.name}</MenuItem>
                                ))
                            }
                        </TextField>
                        <TextField
                            id='search_order_type'
                            label={t('express_type')}
                            name="type"
                            variant="outlined"
                            value={expressType}
                            onChange={(e) => {
                                setExpressType(e.target.value)
                            }}
                            select
                            style={{ width: 100, marginRight: 20 }}
                        >
                            <MenuItem value={-1}>{t('all')}</MenuItem>
                            <MenuItem value={1}>{t('yes')}</MenuItem>
                            <MenuItem value={0}>{t('no')}</MenuItem>
                        </TextField>
                        <TextField
                            id='updatetoolbox_set_signature_required_type'
                            label={t('signature_required')}
                            name="type"
                            variant="outlined"
                            value={signatureType}
                            onChange={(e) => {
                                setSignatureType(e.target.value)
                            }}
                            select
                            style={{ width: 150, marginRight: 20 }}
                        >
                            <MenuItem value={-1}>{t('all')}</MenuItem>
                            <MenuItem value={1}>{t('yes')}</MenuItem>
                            <MenuItem value={0}>{t('no')}</MenuItem>
                        </TextField>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'pointer'
                            }}
                        >
                            <Checkbox
                                id='updatetoolbox-orderlistdownload-islg-checkbox'
                                color='secondary'
                                checked={isLg}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setIsLg(1);
                                    } else {
                                        setIsLg(0);
                                    }
                                }}
                            />
                            <div>{t('lg_filter')}</div>
                        </div>
                    </div>

                    <div className={classes.searchGroup}>
                        <TextField
                            id='updatetoolbox_carrier_type_textfield'
                            label={t('carrier_type')}
                            name="type"
                            variant="outlined"
                            value={carrierType}
                            onChange={(e) => {
                                setCarrierType(e.target.value)
                            }}
                            select
                            style={{ width: 100, marginRight: 20 }}
                        >
                            <MenuItem value={-1}>{t('all')}</MenuItem>
                            <MenuItem value={1}>{'UniUni'}</MenuItem>
                            <MenuItem value={2}>{'NB'}</MenuItem>
                        </TextField>
                        <Autocomplete
                            id='filter_state_list'
                            multiple
                            options={filterStateList || []}
                            getOptionLabel={(option) => option.text}
                            filterSelectedOptions
                            limitTags={1}
                            onChange={(event, value) => {
                                setFilterStates(value);
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    label={t('filter_states')}
                                />
                            )}
                            style={{ width: 540 }}
                            value={filterStates}
                            disabled={filterStates.length === filterStateList.length}
                        />

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Checkbox
                                color="secondary"
                                onClick={handleFilterStateAll}
                                checked={filterStates.length === filterStateList.length}
                            />
                            <span>{t('all')}</span>
                        </div>
                    </div>
                </div>
                <div className={classes.buttonGroup}>
                    <Button
                        color="primary"
                        variant="contained"
                        disabled={loading || disabled}
                        className={classes.button}
                        onClick={handleSubmit}
                        style={{ marginRight: 20 }}
                    >
                        {t('fetch_data')}
                    </Button>
                    <ExcelFile
                        filename="order_lists"
                        element={
                            <Button
                                color="primary"
                                variant="contained"
                                disabled={loading || data.length === 0}
                                className={classes.button}
                            >
                                {t('download_excel')}
                            </Button>
                        }
                    >
                        <ExcelSheet data={data[1]} name="Order List">
                            <ExcelColumn label="tno" value="tno" />
                            <ExcelColumn label="warehouse" value="name" />
                            <ExcelColumn label="state" value="state" />
                            <ExcelColumn label="reference" value="reference" />
                            <ExcelColumn label="sub_reference" value="sub_reference" />
                            <ExcelColumn label="bag_no" value="bag_no" />
                            <ExcelColumn label="internal_account_number" value="internal_account_number" />
                            <ExcelColumn label="service_number" value="shipping_staff_id" />
                            <ExcelColumn label="consignee" value="consignee" />
                            <ExcelColumn label="address" value="address1" />
                            <ExcelColumn label="city" value="city" />
                            <ExcelColumn label="190_pathtime" value="pathTime_190" />
                            <ExcelColumn label="199_pathtime" value="pathTime_199" />
                        </ExcelSheet>
                        <ExcelSheet data={data[0]} name="Not Found">
                            <ExcelColumn label={searchType} value={searchType.slice(0, -1)} />
                        </ExcelSheet>
                    </ExcelFile>
                    <FullscreenLoading open={loading} />
                </div>
            </div>
        </>
    );
}

export default OrderListDownload;
